import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import { Toast } from "vant";
import { ActivitySolicitation, activityDescription, activityDescriptionEnd } from "./modules/ActivitySolicitation";
import { guaguale, luckyDraw, rotaryTable, ShakeIt, WinningDetails } from "./modules/InteractiveLottery";
import { invoiceAdd, invoiceSelect } from "./modules/invoiceLottery";
import { vote, eventDetails } from "./modules/vote";
import { sectionPreview } from "./modules/sectionPreview";
import { InternetPolitics, commonProblem, myPolitics, myRespont, politicsDetail } from "./modules/InternetPolitics";
import { stormPassAnswer, unpublished, ranking, startThrough } from "./modules/stormPassAnswer";
import { ayAnswer, ayunpublished, ayranking, aystartThrough } from "./modules/ayAnswer";
import { questions,questionsDetails,answer,answerDetails,askingQuestions,reply,userQuestionsAnswer,search} from "./modules/quertionsAndAnswer";
import { studyCentre , seriesList , seriesDetail, seriesCourses , classifyList , myStudy ,myAnswer,studyForm  } from "./modules/studyCentre";
import {lotteryInteractive,awardList,wheel,InteractiveRule,myPrizeDetail,myPrizeList,} from "./modules/LotteryInteractive"
import {liveView} from "./modules/liveView"
import {liveViewH5} from "./modules/liveViewH5"
import {noPermission,excessive,noPermissionH5,excessiveH5} from "./modules/noPermission"
Vue.use(VueRouter);
//页面文件引入
//路由配置audioShare
const constantRoutes = [ActivitySolicitation, activityDescription, guaguale, luckyDraw, rotaryTable, ShakeIt, WinningDetails, invoiceAdd, invoiceSelect,
  vote, eventDetails, activityDescriptionEnd, sectionPreview, InternetPolitics, commonProblem, myPolitics, myRespont, politicsDetail, stormPassAnswer, unpublished, ranking, startThrough,
  ayAnswer, ayunpublished, ayranking, aystartThrough,questions,questionsDetails,answer,answerDetails,askingQuestions,reply,userQuestionsAnswer,search,studyCentre,seriesList,seriesDetail,seriesCourses,classifyList,myStudy,myAnswer,studyForm,
  lotteryInteractive,awardList,wheel,InteractiveRule,myPrizeDetail,myPrizeList,liveView,noPermission,excessive,liveViewH5,noPermissionH5,excessiveH5,
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    meta: {
      hidden: false,
      name: "login"
    },
  },
  {
    path: "/signup",
    component: () => import("@/views/ayAnswer/signup"),
    meta: {
      hidden: false,
      name: "signup"
    },
  },

  {
    path: "/loginPh",
    component: () => import("@/views/login/loginPh"),
    meta: {
      hidden: false,
      name: "login"
    },
  },
  {
    path: "/ForgotPassword",
    component: () => import("@/views/login/ForgotPassword"),
    meta: {
      hidden: false,
      name: "login"
    },
  },
  {
    path: "/register",
    component: () => import("@/views/login/register"),
    meta: {
      hidden: false,
      name: "login"
    },
  },

  {
    path: "/error",
    component: () => import("@/views/error"),
    meta: {
      hidden: false,
    },
  },
  {
    path: "/rulesOfGame",
    component: () => import("@/components/rulesOfGame"),
    meta: {
      hidden: false,
    },
  },
  {
    path: "/text",
    component: () => import("@/views/sectionPreview/text.vue"),
    meta: {
      hidden: false,
    },
  }
];
const router = new VueRouter({
  mode: "history",
  routes: constantRoutes,
});

router.beforeEach((to, from, next) => {
  // console.log('asads', window.localStorage.getItem('webTenId')==='undefined');
  if (window.localStorage.getItem('webTenId') ==='undefined') {
    window.localStorage.removeItem('webTenId')
  }
  if (window.localStorage.getItem('webTenId') == null) {
    window.localStorage.setItem("webTenId", to.query.webTenId)
    store.state.webTenId = to.query.webTenId
  }
  if (to.meta.name == "login") {
    if (!to.query.webTenId && to.meta.hidden) {
      next({
        path: "/error",
      });
    } else {
      next()
    }
  } else {
    next()
  }




});

//修改title
// router.beforeEach((to, from, next) => {
//     document.title = to.meta.title;
//     next();
// });

/* 路由异常错误处理，尝试解析一个异步组件时发生错误，重新渲染目标页面 */
// router.onError((error) => {
//   console.log(error);
//   const pattern = /Loading chunk (\d)+ failed/g;
//   const isChunkLoadFailed = error.message.match(pattern);
//   const targetPath = router.history.pending.fullPath;
//   if (isChunkLoadFailed) {
//     router.replace(targetPath);
//   }
// })

export default router;